<div class="modal-header">
    <h4 class="modal-title pull-left" >{{ data.titre }} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); impSelect = false;">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" style="height: auto">
    <div class="row mail">
        <div [ngClass]="{'col-sm-6': showPJ, 'col-sm-12': !showPJ}">
            <div class="form-group col-sm-12">
                <label class="col-sm-2" for="from" style="padding: 0;"> De : </label>
                <input type="email" class="form-control col-sm-10" id="from"  [(ngModel)]="data.expediteur">
            </div>
            <div class="form-group col-sm-12">
                <label  class="col-sm-2" for="to" style="padding: 0;"> A : </label>
                <input type="email" class="form-control col-sm-10" id="to"  [(ngModel)]="data.destinataire">
            </div>
            <div class="form-group col-sm-12">
                <label class="col-sm-2" for="cc" style="padding: 0;"> CC : </label>
                <input type="email" class="form-control col-sm-10" id="cc"  [(ngModel)]="data.cc">
            </div>
            <div class="form-group col-sm-12">
                <label class="col-sm-2" for="bcc" style="padding: 0;"> BCC : </label>
                <input type="email" class="form-control col-sm-10" id="bcc"  [(ngModel)]="data.bcc">
            </div>
            <div class="form-group col-sm-12">
                <label class="col-sm-2" for="object" style="padding: 0;">Sujet : </label>
                <input type="text" class="form-control col-sm-10" id="object"  [(ngModel)]="data.sujet">
            </div>
            <div class="form-group col-sm-12">
                <label for="from">Contenu : </label>
                <textarea class="form-control" rows="10" [(ngModel)]="data.contenu"></textarea>
            </div>
            <div class="form-group col-sm-12" *ngIf="aUnSignature">
                <label for="from">Avec signature  </label>
                <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                    [(ngModel)]="data.isEnvoiImageSignature">
                <img *ngIf="cheminSignature" src="{{ cheminSignature }}" alt="{{ cheminSignature }}" style="max-width: 100px; width: auto; margin-left: 10px"/>
            </div>
        </div>
        
        <div *ngIf="showPJ" class="col-sm-6" style="padding: 0px">
            <div class="col-sm-12" style="padding: 10px 0 0;">
              <div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%; padding: 0px" (click)="common.outSide($event)">
                <div class="header col-sm-12">
                  <div class="col-sm-6" style="font-size: 17px">
                    <button class="btn-add" id="addLigne" (click)="addLigne()">
                      <i class="fa fa-plus"></i>
                    </button>
                    <span (click)="addLigne()">Ajouter</span>
                  </div>
                  <div class="col-sm-6 text-right">
                    <h4> Liste des documents </h4>
                  </div>
                </div>
                <div class="col-sm-12 ligneBon liste">
                  <ngx-datatable style="height: 100%" class="material document" [rows]="listDocumentsPJ"
                    [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="40"
                    [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                    [loadingIndicator]="loadingIndicator">
                    <ngx-datatable-column prop="nomFichierOriginal">
                      <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                          <span class="uppercase"> Fichier </span>
                        </div>
                      </ng-template>
                      <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div *ngIf="row.id">
                          {{value}}
                        </div>
                        <div *ngIf="!row.id">
                          <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)" multiple
                            type="file"  accept="{{ common.extFichierImgEtTexte }}"  />
                          <div class="input-group">
                            <input type="text" class="form-control" [(ngModel)]="row.nomFichierOriginal" readonly>
                            <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i>
                              Parcourir </label>
                          </div>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [width]="70" [sortable]="false" [canAutoResize]="false"
                      [draggable]="false" [resizeable]="false">
                      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                        <button class="btn-detail" (click)="deleteLigne(row)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </div>
              </div>
            </div>
        </div>
    </div>
    
    <div class="text-right" style="margin-top: 15px;">
        <button type="button" class=" btn-sendmail" (click)="handleBtnPieceJointe()" *ngIf="isBtnPieceJointe" style="margin-right: 5px"> Pièce jointe </button>
        <button type="button" class=" btn-sendmail" (click)="valider()" style="margin-right: 5px"> Valider </button>
        <button type="button" class=" btn-closemail" (click)="common.closeModal(); annuler();"> Annuler </button>
    </div>
</div>

<ng-template #dialoguePieceJointe>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Choix du type de mail </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <h4 style="margin: 0px 0px 7px 0px">Gestion de documents</h4>
        <div>
            <div>Documents de la facture</div>
            <div class="ligneBon col-sm-12" [ngClass]="{'full': viewFull}" style="padding: 0px">
                <ngx-datatable style="height: 100%" class="material" [rows]="listDocumentsFacture"
                    [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
                    [messages]="{emptyMessage: 'Pas de lignes à afficher'}">
                    <ngx-datatable-column [width]="70" [sortable]="false" [canAutoResize]="false"
                        [draggable]="false" [resizeable]="false">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                            let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> </span>
                            </div>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" [(ngModel)]="row.isChecked"
                                [ngClass]="{'regular-checkbox-checked': row.isChecked}" />
                        </ng-template>
                    </ngx-datatable-column>
                    
                    <ngx-datatable-column name="Libelle" prop="article.code" [width]="215">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                            let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> Libellé </span>
                            </div>
                        </ng-template>
                        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                            <div class="getID" id="{{rowIndex}}" class="getID">
                                <span (click)="openDocFactNewTab(row)" style="cursor: pointer">{{ row.description }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>            
                </ngx-datatable>
            </div>
            
            <div>Documents des bons</div>
            <div class="ligneBon col-sm-12" [ngClass]="{'full': viewFull}" style="padding: 0px">
                <ngx-datatable style="height: 100%" class="material" [rows]="listDocumentsBon"
                    [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
                    [messages]="{emptyMessage: 'Pas de lignes à afficher'}">
                    <ngx-datatable-column [width]="70" [sortable]="false" [canAutoResize]="false"
                        [draggable]="false" [resizeable]="false">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                            let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> </span>
                            </div>
                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" [(ngModel)]="row.isChecked"
                                [ngClass]="{'regular-checkbox-checked': row.isChecked}" />
                        </ng-template>
                    </ngx-datatable-column>                    
                    
                    <ngx-datatable-column name="Libelle" prop="article.code" [width]="215">
                        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                            let-sort="sortFn">
                            <div class="tableheader">
                                <span class="uppercase"> Libellé </span>
                            </div>
                        </ng-template>
                        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                            <div class="getID" id="{{rowIndex}}" class="getID">
                                <span (click)="openDocBonNewTab(row)" style="cursor: pointer">{{ row.description }}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>            
                </ngx-datatable>
            </div>            

            <div class="text-right" style="margin-top: 15px;">
                <button type="button" class=" btn-close btn-valider" (click)="handleBtnValiderPJ()">
                    Valider </button>&nbsp;
                <button type="button" class=" btn-close" (click)="common.closeModal()"> Fermer </button>
            </div>
        </div>
    </div>
</ng-template>